var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',{staticClass:"main-card-box"},[_c('el-alert',{attrs:{"description":"系统错误","show-icon":"","title":"500","type":"error"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }